import { combineReducers } from 'redux'

import { wholesalerReducer } from './wholesalerReducer'
import { wholesalersReducer } from './wholesalersReducer'

export const wholesaleReducer = combineReducers({
  wholesalers: wholesalersReducer,
  wholesaler: wholesalerReducer
})
